import { lazy } from 'react'

export const RegistryListLazy = lazy(
	() => import('Pages/pp/contractsRegistry/components/RegistryList/RegistryList')
)
